import { ContainerModule } from 'inversify'
import { DeviceStore } from 'store/device'
import TYPES from '../../config/inversify.types'
import { DeviceServiceImpl } from './device.service.impl'

export const DeviceModule = new ContainerModule((bind) => {
    bind(TYPES.DeviceService).to(DeviceServiceImpl).inSingletonScope()
    bind(TYPES.DeviceStore).to(DeviceStore).inSingletonScope()
})
